import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class PromotionsApi extends Api {
  constructor() {
    super('promo/promotions/');
  }

  approve(id, data) {
    return this.buildQuery(
      'post',
      {
        data,
      },
      `${id}/approve`,
    );
  }

  memberApprove(id, data) {
    return this.buildQuery(
      'post',
      {
        data,
      },
      `${id}/member`,
    );
  }

  checkMemberByCompany(id, company_id) {
    return this.buildQuery(
      'get',
      {
        params: {
          company_id,
        },
      },
      `${id}/member_by_company`,
    );
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/promotions.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }

  handleApproveOrReject(id, data) {
    this.buildQuery('post', data, `${id}/approve`);
  }

  createPromo(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      '',
    );
  }

  update(id, data) {
    return this.buildQuery(
      'put',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      id,
    );
  }

  deleteFile(id, fileId) {
    return this.buildQuery(
      'delete',
      {
        data: {
          ids: fileId,
        },
      },
      `${id}/remove_attachments`,
    );
  }
}

export default PromotionsApi;
